import { useEffect } from 'react';
import { useRouter } from 'next/router';

import { useAppSelector } from '@src/hooks/index';

// Used to redirect users to their portfolio, account or login page.
const PortfolioRedirectPage = () => {
    const { user, loading } = useAppSelector((state) => state.auth);
    const router = useRouter();

    useEffect(() => {
        if (loading) return;
        if (user) {
            router.push('/portfolio/' + user.wallet_address);
        } else {
            router.push('/login');
        }
    }, [router, user, loading]);

    return <></>;
};

export default PortfolioRedirectPage;
